// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* StatsPage - Clean, data-focused design */

.stats-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--surface-color);
}

.back-link {
  color: var(--text-secondary);
  text-decoration: none;
  font-size: var(--font-size-base);
  padding: var(--spacing-xs) var(--spacing-md);
  border-radius: var(--border-radius);
  transition: all 0.2s ease;
}

.back-link:hover {
  color: var(--accent-color);
  background-color: var(--surface-color);
}

/* Loading & Error States */
.stats-loading,
.stats-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  color: var(--text-muted);
}

.retry-button {
  margin-top: var(--spacing-md);
  padding: var(--spacing-sm) var(--spacing-lg);
  background-color: var(--accent-color);
  color: white;
  border-radius: var(--border-radius);
  font-size: var(--font-size-base);
}

.retry-button:hover {
  background-color: #0052a3;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--spacing-lg);
  margin-top: var(--spacing-xl);
}

/* Stat Cards */
.stat-card {
  background-color: var(--background-color);
  border: var(--border-width) solid var(--border-color);
  border-radius: var(--border-radius);
  padding: var(--spacing-lg);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease;
}

.stat-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.stat-card.large {
  grid-column: span 2;
}

.stat-card.wide {
  grid-column: 1 / -1;
}

.stat-label {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: var(--spacing-sm);
  font-weight: 500;
}

.stat-value {
  font-size: 2.5rem;
  font-weight: 300;
  color: var(--text-primary);
  line-height: 1.2;
  margin-bottom: var(--spacing-xs);
}

.stat-sublabel {
  font-size: var(--font-size-sm);
  color: var(--text-muted);
}

/* Language Pairs List */
.language-pairs-list {
  margin-top: var(--spacing-md);
}

.language-pair-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-sm) 0;
  border-bottom: var(--border-width) solid var(--border-color);
}

.language-pair-item:last-child {
  border-bottom: none;
}

.language-pair-info {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.pair-rank {
  font-weight: 600;
  color: var(--text-muted);
  min-width: 24px;
}

.pair-languages {
  font-size: var(--font-size-base);
  color: var(--text-primary);
}

.pair-count {
  font-size: var(--font-size-lg);
  font-weight: 500;
  color: var(--accent-color);
}

/* Refresh Section */
.refresh-section {
  display: flex;
  justify-content: center;
  margin-top: var(--spacing-xl);
  margin-bottom: var(--spacing-xl);
}

.refresh-button {
  padding: var(--spacing-sm) var(--spacing-lg);
  background-color: var(--surface-color);
  border: var(--border-width) solid var(--border-color);
  color: var(--text-secondary);
  border-radius: var(--border-radius);
  font-size: var(--font-size-base);
  transition: all 0.2s ease;
}

.refresh-button:hover {
  background-color: var(--background-color);
  border-color: var(--accent-color);
  color: var(--accent-color);
}

/* Responsive Design */
@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }

  .stat-card.large,
  .stat-card.wide {
    grid-column: 1;
  }

  .stat-value {
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/StatsPage.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gCAAgC;EAChC,4CAA4C;EAC5C,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA,2BAA2B;AAC3B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,qCAAqC;EACrC,YAAY;EACZ,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE,yCAAyC;EACzC,qDAAqD;EACrD,mCAAmC;EACnC,0BAA0B;EAC1B,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,sCAAsC;EACtC,qDAAqD;EACrD,4BAA4B;EAC5B,mCAAmC;EACnC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* StatsPage - Clean, data-focused design */\n\n.stats-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--surface-color);\n}\n\n.back-link {\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-size: var(--font-size-base);\n  padding: var(--spacing-xs) var(--spacing-md);\n  border-radius: var(--border-radius);\n  transition: all 0.2s ease;\n}\n\n.back-link:hover {\n  color: var(--accent-color);\n  background-color: var(--surface-color);\n}\n\n/* Loading & Error States */\n.stats-loading,\n.stats-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  color: var(--text-muted);\n}\n\n.retry-button {\n  margin-top: var(--spacing-md);\n  padding: var(--spacing-sm) var(--spacing-lg);\n  background-color: var(--accent-color);\n  color: white;\n  border-radius: var(--border-radius);\n  font-size: var(--font-size-base);\n}\n\n.retry-button:hover {\n  background-color: #0052a3;\n}\n\n/* Stats Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: var(--spacing-lg);\n  margin-top: var(--spacing-xl);\n}\n\n/* Stat Cards */\n.stat-card {\n  background-color: var(--background-color);\n  border: var(--border-width) solid var(--border-color);\n  border-radius: var(--border-radius);\n  padding: var(--spacing-lg);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  transition: all 0.2s ease;\n}\n\n.stat-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  transform: translateY(-2px);\n}\n\n.stat-card.large {\n  grid-column: span 2;\n}\n\n.stat-card.wide {\n  grid-column: 1 / -1;\n}\n\n.stat-label {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: var(--spacing-sm);\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 2.5rem;\n  font-weight: 300;\n  color: var(--text-primary);\n  line-height: 1.2;\n  margin-bottom: var(--spacing-xs);\n}\n\n.stat-sublabel {\n  font-size: var(--font-size-sm);\n  color: var(--text-muted);\n}\n\n/* Language Pairs List */\n.language-pairs-list {\n  margin-top: var(--spacing-md);\n}\n\n.language-pair-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--spacing-sm) 0;\n  border-bottom: var(--border-width) solid var(--border-color);\n}\n\n.language-pair-item:last-child {\n  border-bottom: none;\n}\n\n.language-pair-info {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.pair-rank {\n  font-weight: 600;\n  color: var(--text-muted);\n  min-width: 24px;\n}\n\n.pair-languages {\n  font-size: var(--font-size-base);\n  color: var(--text-primary);\n}\n\n.pair-count {\n  font-size: var(--font-size-lg);\n  font-weight: 500;\n  color: var(--accent-color);\n}\n\n/* Refresh Section */\n.refresh-section {\n  display: flex;\n  justify-content: center;\n  margin-top: var(--spacing-xl);\n  margin-bottom: var(--spacing-xl);\n}\n\n.refresh-button {\n  padding: var(--spacing-sm) var(--spacing-lg);\n  background-color: var(--surface-color);\n  border: var(--border-width) solid var(--border-color);\n  color: var(--text-secondary);\n  border-radius: var(--border-radius);\n  font-size: var(--font-size-base);\n  transition: all 0.2s ease;\n}\n\n.refresh-button:hover {\n  background-color: var(--background-color);\n  border-color: var(--accent-color);\n  color: var(--accent-color);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .stat-card.large,\n  .stat-card.wide {\n    grid-column: 1;\n  }\n\n  .stat-value {\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
